// extracted by mini-css-extract-plugin
export default {"dragPerfFix":"cy3e7gmE","dragPerfShow":"bLzMJWuq"};